import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useModules } from "@/auth/ModulesContext";
import { useAuth } from "@/auth/AuthContext";
import { useIsDemo } from "@/demo/DemoContext";
import { TryItYourself } from "@/demo/TryItYourself";
import { BankLines } from "@/books/BankLines";
import { BooksHome } from "@/books/BooksHome";
import { BooksSetup } from "@/books/BooksSetup";
import { BooksSettings } from "@/books/BooksSettings";
import { BookRules } from "@/books/BookRules";
import { GeneralLedger } from "@/books/GeneralLedger";
import { PostingIssues } from "@/books/PostingIssues";
import { BalanceSheetReport, ProfitAndLossReport, TrialBalanceReport } from "@/books/Reports";
import { ReportsOverview } from "@/books/ReportsOverview";
import { CashFlowReport } from "@/books/CashFlowReport";
import { ChartOfAccounts } from "@/books/ChartOfAccounts";

/** S1: the Books area is hidden without the `books` module; a direct link goes home. */
function BooksGate({ children }: { children: ReactNode }) {
  const { modules, holdsModule } = useModules();
  if (modules === null) return null;
  if (!holdsModule("books")) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export const BooksHomePage = () => (
  <BooksGate>
    <BooksHomeWithDemoTasks />
  </BooksGate>
);

function BooksHomeWithDemoTasks() {
  const isDemo = useIsDemo();
  const { user } = useAuth();
  return <BooksHome intro={isDemo ? <TryItYourself userId={user?.userId} /> : null} />;
}
export const BooksSetupPage = () => <BooksGate><BooksSetup /></BooksGate>;
export const BooksReportsPage = () => <BooksGate><ReportsOverview /></BooksGate>;
export const BooksAccountsPage = () => <BooksGate><ChartOfAccounts /></BooksGate>;
export const BooksCashFlowPage = () => <BooksGate><CashFlowReport /></BooksGate>;
export const BooksTrialBalancePage = () => <BooksGate><TrialBalanceReport /></BooksGate>;
export const BooksProfitAndLossPage = () => <BooksGate><ProfitAndLossReport /></BooksGate>;
export const BooksBalanceSheetPage = () => <BooksGate><BalanceSheetReport /></BooksGate>;
export const BooksLedgerPage = () => <BooksGate><GeneralLedger /></BooksGate>;
export const BooksPostingsPage = () => <BooksGate><PostingIssues /></BooksGate>;
export const BooksSettingsPage = () => <BooksGate><BooksSettings /></BooksGate>;
export const BooksBankLinesPage = () => <BooksGate><BankLines /></BooksGate>;
export const BooksRulesPage = () => <BooksGate><BookRules /></BooksGate>;
